/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-extraneous-dependencies */
import React, { FC } from 'react';
import style from './MissingDataPage.scss';
import { Button, Heading, List, Text } from '../../liberis-component-library';

const containerId = 'container';

interface ExplainerProps {
  onContinue: () => void;
}

const MissingDataExplainer: FC<ExplainerProps> = ({
  onContinue,
}): React.JSX.Element => {
  return (
    <main id={containerId} className={style.container}>
      <div className={style.content}>
        <Heading heading='h2'>We need to finalise your details</Heading>
        <Text className={style.subTitle}>
          We need to collect some final details from you to complete your advance.
          This process will only take a few minutes to complete.
        </Text>
        <div className={style.contentContainer}>
          <Heading heading='h3'>What we’ll need</Heading>
          <List className={style.list}>
            <li className={style.listItem}>Your business ownership percentage</li>
            <li className={style.listItem}>Social security number for verification</li>
            <li className={style.listItem}>Sign agreement</li>
          </List>
          <Button className={style.button} onClick={onContinue}>Continue</Button>
        </div>
      </div>
    </main>
  );
};

export default MissingDataExplainer;
